<script setup lang="ts">
import { NotivueItem } from 'notivue';
import type { NotivueItemProps } from './base-toast.types';

interface Props {
  item: NotivueItem<NotivueItemProps>;
}

defineProps<Props>();

defineSlots<{
  icon(): void;
  content(): void;
}>();
</script>

<template>
  <div
    class="flex w-[450px] flex-nowrap gap-3 rounded-2xl rounded-r-none bg-backgrounds-darkgrey p-4"
  >
    <div class="flex w-1/12 items-start justify-center">
      <slot v-if="!item.props.image && !item.props.icon" name="icon" />
      <div v-if="item.props.image" class="overflow-hidden rounded-full">
        <img class="w-[80px] align-top" :src="item.props.image" />
      </div>
      <template v-if="item.props.icon">
        <IconifyIcon
          :icon="item.props.icon.name"
          width="40px"
          :class="`text-${item.props.icon.color}`"
        ></IconifyIcon>
      </template>
    </div>
    <div class="flex w-10/12 flex-col justify-center">
      <slot name="content" />
      <div v-if="item.props.actions" class="mt-1 flex gap-3">
        <button
          v-for="action in item.props.actions"
          :key="action.text"
          class="text-sm underline underline-offset-2"
          @click="action.onClick"
        >
          {{ action.text }}
        </button>
      </div>
    </div>
    <div class="flex w-1/12 items-start justify-end">
      <button class="ml-auto cursor-pointer outline-0" @click="item.clear">
        X
      </button>
    </div>
  </div>
</template>

<style scoped></style>
